import { CheckademicLogo } from '@/components/CheckademicLogo';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { portalNavStyles } from '@/styles/portalPageStyles';

interface PortalNavProps {
  currentPage?: 'home' | 'pricing' | 'contact';
}

function PortalNav({ currentPage }: PortalNavProps) {
  const { isMobile } = useMediaQuery();

  // Only show Pricing/Contact links on portal site (not on tenant subdomains)
  const hostname = window.location.hostname;
  const isPortalSite =
    hostname === 'checkademic.com' ||
    hostname === 'www.checkademic.com' ||
    hostname === 'checkademic.dev' ||
    hostname === 'www.checkademic.dev' ||
    hostname === 'localhost';

  const linkStyle = isMobile ? portalNavStyles.linkMobile : portalNavStyles.link;

  return (
    <nav style={isMobile ? portalNavStyles.navMobile : portalNavStyles.nav}>
      <div style={portalNavStyles.content}>
        <a href="/" style={{ textDecoration: 'none' }}>
          <CheckademicLogo
            height={isMobile ? '36px' : '44px'}
            primaryColor="white"
            accentColor="#F28D4A"
            textColor="white"
          />
        </a>
        {isPortalSite && (
          <div style={isMobile ? portalNavStyles.linksMobile : portalNavStyles.links}>
            <a
              href="/pricing"
              style={{
                ...linkStyle,
                ...(currentPage === 'pricing' ? portalNavStyles.linkActive : {}),
              }}
            >
              Pricing
            </a>
            <a
              href="/contact"
              style={{
                ...linkStyle,
                ...(currentPage === 'contact' ? portalNavStyles.linkActive : {}),
              }}
            >
              Contact
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}

export default PortalNav;
